import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DonateNowModule } from '../donate-now/donate-now.module';
import { FrCardModule } from '../fr-card/fr-card.module';
import { PlaceholderLoaderModule } from '../placeholder-loader/placeholder-loader.module';
import { DonationMethodsComponent } from './components/donation-methods/donation-methods.component';
import { InViewportModule } from 'ng-in-viewport';
import { InputModule } from '../input/input.module';
import { IntlInputModule } from '../intl-input/intl-input.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TipCardModule } from '../tip-card/tip-card.module';
import { UpiIconsComponent } from './components/upi-icons/upi-icons.component';
import { SharedModule } from '../../shared/shared.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { PaymentOtdModule } from '../payment-otd/payment-otd.module';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { AcknowledgeFormComponent } from 'src/app/core/acknowledge-form/acknowledge-form.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FrCardModule,
    DonateNowModule,
    PlaceholderLoaderModule,
    AcknowledgeFormComponent,
    InViewportModule,
    InputModule,
    IntlInputModule,
    ReactiveFormsModule,
    TipCardModule,
    ModuleLoaderModule,
    PaymentOtdModule,
    MatCardModule,
    MatIconModule
  ],
  declarations: [DonationMethodsComponent , UpiIconsComponent],
  exports: [DonationMethodsComponent]
})
export class DonationMethodsModule { }
